export default function({id}, {PeriodStartDate}, view) {
  return `/approval/${id}/${PeriodStartDate}/${view}`;
}
